import * as types from '../types';
import { audit } from '~api';

const {
  apiGetClientType,
  apiGetClientAuditList,
  apiGetClientAuditDetail,
  apiGetAuditContactsList,
  apiPassClientAudit,
  apiRefuseClientAudit,
  apiHandleDeleteAudit,
} = audit;

export default {
  // 客户审核-获取客户类型
  getClientType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiGetClientType(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CLIENT_TYPE, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },

  getClientAuditList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiGetClientAuditList(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CLIENT_AUDIT_LIST, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },

  getClientAuditDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiGetClientAuditDetail(payload).then((res) => {
        if (res.data) {
          commit(types.GET_CLIENT_AUDIT_DETAIL, res.data);
        }
        resolve(res);
      }).catch((e) => {
        reject(e);
      });
    });
  },

  async getAuditContactsList({ commit }, payload) {
    const responseObj = await apiGetAuditContactsList(payload);
    commit(types.GET_AUDIT_CONTACTS_LIST, responseObj.data);
  },

  passClientAudit({ commit }, payload) {
    return apiPassClientAudit(payload);
  },

  refuseClientAudit({ commit }, payload) {
    return apiRefuseClientAudit(payload);
  },
  // 删除
  deleteHandleAudit({ commit }, payload) {
    return apiHandleDeleteAudit(payload);
  },

};
